import PersonRegistrationSearchService from '../services/person-registration-search-service';

export const personRegistrationSearch = {
  namespaced: true,
  state: {
    searchResult: null,
    pageNumber: 0,
    lastSearchConfig: null,
  },
  actions: {
    search({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'standard';
      commit('setLastSearchConfig', data);
      return PersonRegistrationSearchService.search(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    searchAdvanced({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'advanced';
      commit('setLastSearchConfig', data);
      return PersonRegistrationSearchService.advancedSearch(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
  },
  mutations: {
    setSearchResult(state, searchResult) {
      state.searchResult = searchResult;
    },
    setLastSearchConfig(state, searchConfig) {
      state.lastSearchConfig = searchConfig;
    },
    setSearchPageNumber(state, newPageNumber) {
      state.pageNumber = newPageNumber;
    },
  },
};
